var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.$style.wrapper, _vm.style]},[_c('div',{class:_vm.$style.dot}),_c('div',{class:_vm.$style.text,attrs:{"data-test-id":"studioPageActivityState"}},[_vm._v(_vm._s(_vm.activity))])])
}
var staticRenderFns = []

export { render, staticRenderFns }